import { render, staticRenderFns } from "./ScoreDialogComponent.vue?vue&type=template&id=e9ed9dc4&scoped=true"
import script from "./ScoreDialogComponent.vue?vue&type=script&lang=js"
export * from "./ScoreDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9ed9dc4",
  null
  
)

export default component.exports